import { yupResolver } from "@hookform/resolvers/yup";
import { Clickable, TextInput } from "artisn-ui-react";
import React, { useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";

import Styles from "./CodeRedemInput.styles";
import { CodeRedemInputProps as Props } from "./CodeRedemInput.types";
import { CodeFormValues } from "./CodeRedemInput.types";
import CorporateInfoModal from "../CorporateInfoModal/CorporateInfoModal";
import Button from "components/global/Button/Button";
import useI18n from "hooks/useI18n";
import { getCorporateFormSchema } from "utils/form.utils";

import InfoSVG from "../../../../public/assets/images/info-white.svg";

const CORPORATE_TICKET_LENGHT = 16;

const CodeRedemInput: React.FC<Props> = props => {
  const { hideInfo = false, className, onApply } = props;
  const t = useI18n();
  const [openInfoModal, setOpenInfoModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const formMethods = useForm<CodeFormValues>({
    mode: "onChange",
    resolver: yupResolver(getCorporateFormSchema(CORPORATE_TICKET_LENGHT))
  });

  const { handleSubmit, register, formState, resetField } = formMethods;
  const { code } = formState.errors ?? {};
  const { isSubmitting } = formState;

  const handleApplyCode: SubmitHandler<CodeFormValues> = async values => {
    const { code } = values;
    if (!code) return;

    setIsLoading(true);
    await onApply(code);
    resetField("code");
    setIsLoading(false);
  };

  const isDisabled = isLoading || isSubmitting;

  return (
    <Styles className={`CodeRedemInput ${className}`}>
      <TextInput
        {...register("code")}
        className="CodeRedemInput__text-input field"
        label={
          <div className="CodeRedemInput__container">
            <p className="CodeRedemInput__label">{t.wallet.inputTitle}</p>
            {!hideInfo ? (
              <Clickable
                className="CodeRedemInput__info"
                onClick={() => setOpenInfoModal(true)}
              >
                <InfoSVG />
              </Clickable>
            ) : null}
          </div>
        }
        placeholder={t.wallet.inputPlaceholder}
        maxLength={CORPORATE_TICKET_LENGHT}
        minLength={CORPORATE_TICKET_LENGHT}
        autoCapitalize="none"
        errorMessage={code?.message}
        autoComplete="off"
        disabled={isDisabled}
      />
      <Button
        className="CodeRedemInput__input-button"
        mode="LINK"
        onClick={handleSubmit(handleApplyCode)}
        type="submit"
        disabled={isDisabled}
        isLoading={isDisabled}
      >
        {t.common.apply}
      </Button>
      <CorporateInfoModal
        opened={openInfoModal}
        onClose={() => {
          setOpenInfoModal(false);
        }}
      />
    </Styles>
  );
};

export default CodeRedemInput;
